/* KeraBiotic LP Version B — page behaviour.

   One controller for the whole page so the buy box, the sticky bar and the
   final CTA always agree on which plan is selected. Sections announce
   themselves through data attributes; nothing here is section-order dependent,
   so the same script serves the hair / skin / gut / beauty variants. */
(function () {
  'use strict';

  /* Every section that needs behaviour references this file, so the same
     <script> lands on the page several times and each tag executes. Without
     this guard the listeners bind twice and toggles cancel themselves out. */
  if (window.__kbbHairB) return;
  window.__kbbHairB = true;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- plans */

  function checkoutBase() {
    var root = document.querySelector('[data-kbb-root]');
    var path = root && root.getAttribute('data-kbb-checkout');
    return path || '/checkout';
  }

  function initPlans() {
    var inputs = Array.prototype.slice.call(document.querySelectorAll('[data-kbb-plan-input]'));
    if (!inputs.length) return;

    var checkoutPath = checkoutBase();

    var segments = Array.prototype.slice.call(document.querySelectorAll('[data-kbb-seg]'));
    var forms = Array.prototype.slice.call(document.querySelectorAll('[data-kbb-buy-form]'));
    var ctaLabels = Array.prototype.slice.call(document.querySelectorAll('[data-kbb-cta-label]'));
    var totals = Array.prototype.slice.call(document.querySelectorAll('[data-kbb-sticky-total]'));

    var selected = null;

    function planFromInput(input) {
      return {
        key: input.value,
        quantity: input.getAttribute('data-quantity') || '1',
        variant: input.getAttribute('data-variant') || '',
        discount: input.getAttribute('data-discount') || '',
        cta: input.getAttribute('data-cta') || '',
        summary: input.getAttribute('data-summary') || '',
        price: parseInt(input.getAttribute('data-price'), 10) || 0,
        perDay: input.getAttribute('data-perday') || '',
        totalMoney: input.getAttribute('data-total-money') || '',
        grossMoney: input.getAttribute('data-gross-money') || '',
        hasDiscount: input.getAttribute('data-has-discount') === '1',
        days: input.getAttribute('data-days') || ''
      };
    }

    function apply(plan, options) {
      selected = plan;

      inputs.forEach(function (input) {
        var on = input.value === plan.key;
        if (input.checked !== on) input.checked = on;
      });

      segments.forEach(function (segment) {
        segment.setAttribute('aria-pressed', segment.getAttribute('data-kbb-seg') === plan.key ? 'true' : 'false');
      });

      forms.forEach(function (form) {
        if (form.hasAttribute('data-kbb-fixed-plan')) return;
        var id = form.querySelector('[name="id"]');
        var qty = form.querySelector('[name="quantity"]');
        var back = form.querySelector('[name="return_to"]');
        if (id && plan.variant) id.value = plan.variant;
        if (qty) qty.value = plan.quantity;
        /* Checkout-Pfad kommt aus dem Liquid (data-kbb-checkout), nicht
           hartkodiert: die LP läuft im englischen Locale, ihr Checkout muss
           trotzdem deutsch sein. Siehe Kommentar in
           sections/zellaforte-kb-hair-b-hero.liquid. */
        /* checkoutPath trägt seit dem shop.app-Fix bereits eine Query
           (skip_shop_pay/auto_redirect) — der Rabatt muss deshalb mit & angehängt
           werden. Mit hartem '?' entstünde eine zweite Query und der Rabattcode
           würde stillschweigend verfallen (Preistest!). */
        var sep = checkoutPath.indexOf('?') > -1 ? '&' : '?';
        if (back) back.value = plan.discount ? checkoutPath + sep + 'discount=' + encodeURIComponent(plan.discount) : checkoutPath;
        form.setAttribute('data-quantity', plan.quantity);
        form.setAttribute('data-price', (plan.price / 100).toFixed(2));
      });

      ctaLabels.forEach(function (node) {
        if (node.hasAttribute('data-kbb-fixed-label')) return;
        if (plan.cta) node.textContent = plan.cta;
      });

      totals.forEach(function (node) {
        node.textContent = plan.summary;
      });

      /* Schluss-Block: Preisanzeige an die Auswahl koppeln.
         Bis 2026-08-22 war dieser Block fest auf 3 Dosen / 139 EUR verdrahtet.
         Wer oben die 30 Tage fuer 49 EUR gewaehlt hatte und bis ans Seitenende
         scrollte, traf dort auf einen Knopf, der 139 EUR kaufte. Der Knopf
         folgt jetzt der Auswahl, also muessen die Zahlen darueber es auch —
         sonst waere der Widerspruch nur verschoben statt behoben. */
      function setzeText(selektor, wert) {
        if (!wert) return;
        Array.prototype.forEach.call(document.querySelectorAll(selektor), function (node) {
          node.textContent = wert;
        });
      }
      setzeText('[data-kbb-close-perday]', plan.perDay);
      setzeText('[data-kbb-close-total]', plan.totalMoney);
      setzeText('[data-kbb-close-days]', plan.days);
      Array.prototype.forEach.call(document.querySelectorAll('[data-kbb-close-was]'), function (node) {
        if (plan.hasDiscount && plan.grossMoney) {
          node.textContent = plan.grossMoney;
          node.hidden = false;
        } else {
          node.hidden = true;
        }
      });

      if (options && options.emit) {
        document.dispatchEvent(new CustomEvent('kbb:planchange', { detail: { plan: plan.key } }));
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) apply(planFromInput(input), { emit: true });
      });
    });

    segments.forEach(function (segment) {
      segment.addEventListener('click', function () {
        var key = segment.getAttribute('data-kbb-seg');
        var match = inputs.filter(function (input) {
          return input.value === key;
        })[0];
        if (match) apply(planFromInput(match), { emit: true });
      });
    });

    var initial = inputs.filter(function (input) {
      return input.checked;
    })[0] || inputs[0];
    apply(planFromInput(initial), { emit: false });
  }

  /* ------------------------------------------------------- lazy video */

  /* Das Dosen-Video wiegt 2,83 MB und sitzt unterhalb der Falz. Mit autoplay
     im Markup zieht der Browser es sofort komplett und blockiert damit alles,
     was oben gerendert werden müsste. Die Quellen stehen deshalb als data-src
     im HTML; erst wenn die Sektion in Sichtweite kommt, werden sie gesetzt und
     die Wiedergabe gestartet. Ohne IntersectionObserver (alte Browser) lädt es
     wie bisher sofort — funktional gleich, nur langsamer. */
  function initLazyVideo() {
    var videos = Array.prototype.slice.call(document.querySelectorAll('video[data-kbb-video]'));
    if (!videos.length) return;

    function aktivieren(video) {
      if (video.dataset.kbbLoaded) return;
      video.dataset.kbbLoaded = '1';
      var quellen = video.querySelectorAll('source[data-src]');
      if (!quellen.length) return;
      Array.prototype.forEach.call(quellen, function (quelle) {
        quelle.setAttribute('src', quelle.getAttribute('data-src'));
        quelle.removeAttribute('data-src');
      });
      video.load();
      var versuch = video.play();
      /* Autoplay kann abgelehnt werden (z. B. Datensparmodus) — dann bleibt
         schlicht das Poster stehen, kein Fehler in der Konsole. */
      if (versuch && typeof versuch.catch === 'function') versuch.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(aktivieren);
      return;
    }

    var beobachter = new IntersectionObserver(
      function (eintraege) {
        eintraege.forEach(function (eintrag) {
          if (!eintrag.isIntersecting) return;
          aktivieren(eintrag.target);
          beobachter.unobserve(eintrag.target);
        });
      },
      /* 300 px Vorlauf: das Video ist geladen, bevor es wirklich im Bild ist. */
      { rootMargin: '300px 0px' }
    );
    videos.forEach(function (video) { beobachter.observe(video); });
  }

  /* ------------------------------------------------- direkter Checkout */

  /* Diese Seite verkauft eine feste Routine — 1 Dose oder 3. Ein normaler
     POST auf /cart/add legt die Menge aber OBEN AUF einen bestehenden
     Warenkorb. Im Test kamen so 5 Dosen plus eine Abo-Zeile im Checkout an,
     während die Seite 3 Dosen zu 139 € versprochen hatte: der Mengenrabatt
     griff zwar, die Summe stimmte aber nicht mehr mit der Aussage der Seite
     überein, und „Einmalkauf · kein Abo" stand neben einem Monatsabo.

     Deshalb vor dem Hinzufügen alle Zeilen dieses Produkts entfernen —
     inklusive Abo-Zeilen, die als eigener line item key derselben Variante
     erscheinen — und danach exakt die gewählte Menge setzen. Andere
     Produkte bleiben unangetastet. Schlägt ein Schritt fehl, greift der
     normale Formular-POST, der Kauf bricht also nie ab. */
  function initDirectCheckout() {
    var busy = false;

    function json(url, body) {
      return fetch(url, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
        credentials: 'same-origin'
      }).then(function (response) {
        if (!response.ok) throw new Error(url + ' → ' + response.status);
        return response.json();
      });
    }

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.hasAttribute || !form.hasAttribute('data-kbb-buy-form')) return;
      if (!window.fetch) return;

      var productId = parseInt(form.getAttribute('data-kbb-product-id'), 10);
      var idField = form.querySelector('[name="id"]');
      var qtyField = form.querySelector('[name="quantity"]');
      var backField = form.querySelector('[name="return_to"]');
      if (!productId || !idField || !qtyField) return;

      /* Nicht stopPropagation: das Tracking der Hero-Sektion hängt am selben
         submit-Event und muss weiterhin feuern. */
      event.preventDefault();
      if (busy) return;
      busy = true;

      /* Zwischen Klick und Weiterleitung laufen bis zu drei Netzwerk-Aufrufe
         nacheinander, ohne das hier sichtbar ein Klick auf Wirkung ausbleibt —
         genau das Muster, das Replay-Vision in mehreren Sitzungen als
         Rage-Click auf diesem Button bestätigt hat. busy verhindert bereits
         doppelte Warenkorb-Anfragen; das hier macht sichtbar, dass der erste
         Klick angekommen ist. */
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.classList.add('is-loading');

      var target = backField && backField.value ? backField.value : checkoutBase();

      json('/cart.js')
        .then(function (cart) {
          var updates = {};
          var stale = 0;
          (cart.items || []).forEach(function (line) {
            if (line.product_id === productId) {
              updates[line.key] = 0;
              stale += 1;
            }
          });
          return stale ? json('/cart/update.js', { updates: updates }) : null;
        })
        .then(function () {
          return json('/cart/add.js', {
            items: [{ id: parseInt(idField.value, 10), quantity: parseInt(qtyField.value, 10) || 1 }]
          });
        })
        .then(function () {
          window.location.href = target;
        })
        .catch(function () {
          busy = false;
          if (submitBtn) submitBtn.classList.remove('is-loading');
          form.submit();
        });
    });
  }

  /* ----------------------------------------------------------- accordions */

  function initAccordions() {
    document.querySelectorAll('[data-kbb-accordion]').forEach(function (root) {
      var multiple = root.getAttribute('data-kbb-accordion') === 'multiple';
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-kbb-accordion-btn]'));

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var open = button.getAttribute('aria-expanded') === 'true';
          if (!multiple) {
            buttons.forEach(function (other) {
              if (other !== button) other.setAttribute('aria-expanded', 'false');
            });
          }
          button.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    });
  }

  /* ------------------------------------------------------- evidence spine */

  function countUp(node) {
    var target = parseFloat(node.getAttribute('data-kbb-count'));
    if (isNaN(target)) return;
    var prefix = node.getAttribute('data-kbb-prefix');
    if (prefix === null) prefix = '+';
    var suffix = node.getAttribute('data-kbb-suffix') || ' %';

    function format(value) {
      return prefix + value.toFixed(1).replace('.', ',') + suffix;
    }

    var settled = format(target);
    if (reduceMotion) {
      node.textContent = settled;
      return;
    }

    var start = Date.now();
    node.textContent = format(0);
    var timer = setInterval(function () {
      var progress = Math.min(1, (Date.now() - start) / 1200);
      node.textContent = format(target * (1 - Math.pow(1 - progress, 3)));
      if (progress >= 1) {
        clearInterval(timer);
        node.textContent = settled;
      }
    }, 32);
  }

  function initEvidence() {
    var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-kbb-evidence]'));
    if (!blocks.length) return;

    function reveal(root) {
      if (root.dataset.kbbRevealed) return;
      root.dataset.kbbRevealed = '1';
      root.querySelectorAll('[data-kbb-bar]').forEach(function (bar) {
        bar.style.transform = 'scaleY(1)';
      });
      root.querySelectorAll('[data-kbb-count]').forEach(countUp);
    }

    if (!('IntersectionObserver' in window)) {
      blocks.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.25 }
    );

    blocks.forEach(function (block) {
      observer.observe(block);
    });
  }

  /* ------------------------------------------------------------- heritage */

  function initHeritage() {
    document.querySelectorAll('[data-kbb-heritage]').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-kbb-heritage-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-kbb-heritage-dot]'));
      if (slides.length < 2) {
        root.querySelectorAll('[data-kbb-heritage-arrow]').forEach(function (arrow) {
          arrow.hidden = true;
        });
        if (slides.length < 2) {
          dots.forEach(function (dot) {
            dot.hidden = true;
          });
        }
      }
      if (!slides.length) return;

      var index = 0;

      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        dots.forEach(function (dot, i) {
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      root.querySelectorAll('[data-kbb-heritage-arrow]').forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          show(index + (arrow.getAttribute('data-kbb-heritage-arrow') === 'next' ? 1 : -1));
        });
      });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          show(i);
        });
      });

      show(0);
    });
  }

  /* -------------------------------------------------------------- gallery */

  /* Die Galerie war die groesste echte Fehlerquelle der Seite: 6 der 8
     Rage-Clicks auf dieser LP gingen auf `button.kbb-gallery__thumb`, nicht
     auf den Kaufknopf. Ursache war diese Funktion — sie setzte `main.src` auf
     ein 1200-Pixel-Bild, das erst in diesem Moment geladen wurde. Ohne
     Vorladen und ohne sichtbare Reaktion passiert auf mobilen Daten nach dem
     Tippen sekundenlang nichts, also tippt man erneut.

     Zwei Massnahmen: die grossen Bilder werden im Leerlauf vorgeladen, damit
     der Wechsel im Normalfall sofort passiert, und bis ein Bild wirklich
     dekodiert ist, zeigt die Flaeche einen Ladezustand. Getauscht wird erst
     nach `onload` — sonst steht kurzzeitig ein leeres Bild im Rahmen. */
  function initGallery() {
    document.querySelectorAll('[data-kbb-gallery]').forEach(function (root) {
      var main = root.querySelector('[data-kbb-gallery-main]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-kbb-gallery-thumb]'));
      if (!main || !thumbs.length) return;

      var rahmen = main.closest('.kbb-gallery__main') || main.parentNode;
      var cache = {};

      function vorladen() {
        thumbs.forEach(function (t) {
          var url = t.getAttribute('data-full');
          if (!url || cache[url]) return;
          var img = new Image();
          img.src = url;
          cache[url] = img;
        });
      }
      /* Im Leerlauf, damit das Vorladen nicht mit dem Erstrendern der Seite
         konkurriert — der Hero muss zuerst da sein. */
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(vorladen, { timeout: 3000 });
      } else {
        window.setTimeout(vorladen, 1500);
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          var alt = thumb.getAttribute('data-alt') || '';

          /* Auswahl sofort markieren, unabhaengig vom Bildladen — das ist die
             Rueckmeldung, die vorher komplett fehlte. */
          thumbs.forEach(function (other) {
            other.setAttribute('aria-current', other === thumb ? 'true' : 'false');
          });
          if (!full) return;

          function einsetzen() {
            main.src = full;
            main.alt = alt;
            if (rahmen) rahmen.classList.remove('is-loading');
          }

          var img = cache[full];
          if (!img) {
            img = new Image();
            img.src = full;
            cache[full] = img;
          }
          if (img.complete && img.naturalWidth) {
            einsetzen();
            return;
          }
          if (rahmen) rahmen.classList.add('is-loading');
          img.onload = einsetzen;
          /* Auch im Fehlerfall tauschen: dann zeigt der Browser sein eigenes
             Fallback statt eines dauerhaften Ladezustands. */
          img.onerror = einsetzen;
        });
      });
    });
  }

  /* --------------------------------------------------------- sticky CTA */

  function initSticky() {
    var bar = document.querySelector('[data-kbb-sticky]');
    if (!bar) return;

    var hero = document.querySelector('[data-kbb-sticky-after]');
    var stoppers = Array.prototype.slice.call(document.querySelectorAll('[data-kbb-sticky-stop]'));
    var blocking = 0;

    function update() {
      var pastHero = true;
      if (hero) {
        var rect = hero.getBoundingClientRect();
        pastHero = rect.bottom < 0;
      }
      bar.classList.toggle('is-visible', pastHero && blocking === 0);
    }

    if ('IntersectionObserver' in window && stoppers.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (!entry.target.dataset.kbbBlocking) {
                entry.target.dataset.kbbBlocking = '1';
                blocking++;
              }
            } else if (entry.target.dataset.kbbBlocking) {
              delete entry.target.dataset.kbbBlocking;
              blocking = Math.max(0, blocking - 1);
            }
          });
          update();
        },
        { threshold: 0 }
      );
      stoppers.forEach(function (stopper) {
        observer.observe(stopper);
      });
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function init() {
    initPlans();
    initDirectCheckout();
    initLazyVideo();
    initAccordions();
    initEvidence();
    initHeritage();
    initGallery();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
